import { render, staticRenderFns } from "./orderBuyDetail.vue?vue&type=template&id=8fb07160&scoped=true"
import script from "./orderBuyDetail.vue?vue&type=script&lang=js"
export * from "./orderBuyDetail.vue?vue&type=script&lang=js"
import style0 from "./orderBuyDetail.vue?vue&type=style&index=0&id=8fb07160&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb07160",
  null
  
)

export default component.exports